import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { ServiceCard } from './components/ServiceCard';
import { SERVICES } from './consts';

export const Services: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.press_page.services.eyebrow')}
				heading={translationKey('corgi.press_page.services.heading')}
				align="center"
			/>
			<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-qa="press-services-grid">
				{SERVICES.map(({ id, ...service }) => (
					<ServiceCard key={id} {...service} />
				))}
			</div>
		</section>
	);
};
